import { styled } from 'styled-components';

import {
  createResponsiveSpacingStyle,
  DefaultIconProps,
  DefaultIconWrapper,
  getColor,
  ResponsiveSpacing,
} from '../../../utils';

type LoadingProps = DefaultIconProps & {
  center?: boolean;

  strokeWidth?: ResponsiveSpacing;
};

export const Loading = ({
  width = 40,
  marginTop = 0,
  marginBottom = 0,
  marginLeft,
  marginRight,
  color = 'black20',
}: LoadingProps) => {
  return (
    <DefaultIconWrapper
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginRight={marginRight}
      marginLeft={marginLeft}
      width={width}
    >
      <AnimatedLoadingSvg viewBox="0 0 128 128" fill="none" color={color} iconHeight={width}>
        <rect x="24" y="56" width="16" height="16" rx="8" className="dot1" />
        <rect x="56" y="36" width="16" height="56" rx="8" className="dot2" />
        <rect x="88" y="56" width="16" height="16" rx="8" className="dot3" />
      </AnimatedLoadingSvg>
    </DefaultIconWrapper>
  );
};

const AnimatedLoadingSvg = styled('svg')<{
  strokeWidthResponsive?: ResponsiveSpacing;
  iconHeight?: ResponsiveSpacing;
  color: string;
}>`
  ${props => props.iconHeight && createResponsiveSpacingStyle('height', props.iconHeight)};

  .dot1 {
    y: 56;
    fill: ${getColor('black10')};
    animation: d58skoo42ad32-anim1 2.4s linear infinite;
  }
  .dot2 {
    y: 56;
    fill: ${getColor('black10')};
    animation: d58skoo42ad32-anim2 2.4s linear infinite;
  }
  .dot3 {
    y: 56;
    fill: ${getColor('black10')};
    animation: d58skoo42ad32-anim3 2.4s linear infinite;
  }

  @keyframes d58skoo42ad32-anim1 {
    0% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    12% {
      y: 36;
      height: 56px;
      fill: ${props => getColor(props.color)};
    }
    25% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
  }
  @keyframes d58skoo42ad32-anim2 {
    0% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    25% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    37% {
      y: 36;
      height: 56px;
      fill: ${props => getColor(props.color)};
    }
    50% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    75% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    87% {
      y: 36;
      height: 56px;
      fill: ${props => getColor(props.color)};
    }
    100% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
  }
  @keyframes d58skoo42ad32-anim3 {
    0% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    50% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
    62% {
      y: 36;
      height: 56px;
      fill: ${props => getColor(props.color)};
    }
    75% {
      y: 56;
      height: 16px;
      fill: ${getColor('black10')};
    }
  }
`;
